import * as THREE from 'three';

export default function calculateBoundingBox(object) {
  const box = new THREE.Box3();
  const result = new THREE.Box3();

  if (!object) return result;

  let objectsRoot = object;
  object.children.forEach((child)=> {
    if (child.type === 'Object3D' && child.name === 'Objects') objectsRoot = child;
  });

  result.makeEmpty();

  object.updateMatrixWorld(true);

  objectsRoot.traverse((node) => {
    if (!node.visible) return;
    if (!node.geometry) return;

    const geometry = node.geometry;

    if (geometry.boundingBox === null) {
      geometry.computeBoundingBox();
    }

    if (geometry.boundingBox.isEmpty() === false) {
      box.copy(geometry.boundingBox);
      node.matrix.compose(node.position, node.quaternion, node.scale);
      node.updateMatrixWorld(true);
      box.applyMatrix4(node.matrixWorld);
      result.union(box);
    }
  });

  return result;
}



// WEBPACK FOOTER //
// ./src/translators/utils/calculateBoundingBox.js